import { FormTextEditor } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { InputLabel } from '@mui/material';

type RiskCharacteristicsAndImpactsFormProps = {
  planIndex: number;
  riskIndex: number;
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const RiskCharacteristicsAndImpactsForm = ({
  planIndex,
  riskIndex,
  isCompletedTh = false,
  isCompletedEn = false,
}: RiskCharacteristicsAndImpactsFormProps) => {
  return (
    <>
      <InputLabel required sx={{ mt: 4, fontWeight: 800 }}>
        ลักษณะความเสี่ยง และ ผลกระทบ
      </InputLabel>
      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.characteristicTh`}
        label="กรุณาอธิบายลักษณะความเสี่ยง และ ผลกระทบ (ไทย)"
        required
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (ไทย)',
        }}
        sx={
          isCompletedTh
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />
      <FormTextEditor
        name={`companyValueIncreasePlans.valueUpPlans.${planIndex}.riskManagement.risks.${riskIndex}.characteristicEn`}
        label="กรุณาอธิบายลักษณะความเสี่ยง และ ผลกระทบ (อังกฤษ)"
        required
        mt={2}
        inputProps={{
          placeholder: 'กรุณาระบุ (อังกฤษ)',
        }}
        sx={
          isCompletedEn
            ? {
                ...disabledFormInputStyles,
              }
            : undefined
        }
      />
    </>
  );
};

export default RiskCharacteristicsAndImpactsForm;
